export const GetFullDate = (date) => {
  if (date) {
    console.log("TYTYTY", typeof date, date);
    return date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear();
  }
  return null;

  // return dateAndTime[0].split('-').reverse().join('-');
};
